import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { createStructuredSelector } from "reselect";
import {
  selectedOfferSelector,
  activeStepDataSelector,
} from "containers/MultistepForm/selectors";
import { nextStep, selectOfferFailed } from "containers/MultistepForm/actions";
import Frame from "../../../ContractStep/Frame";

class FypnIbvFrame extends Component {
  receiveMessage = (event) => {
    if (!event) return;

    console.log("[fypn ibv] message", {
      origin: event.origin,
      type: typeof event.data,
      data: event.data,
    });

    let data = event.data;
    if (typeof data === "string") {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return;
      }
    }
    if (!data || typeof data !== "object") return;

    const { nextStep, selectOfferFailed, selectedOffer } = this.props;

    const status =
      typeof data.response?.Status === "string"
        ? data.response.Status.toUpperCase()
        : "";
    if (!status) return;

    if (data.success === true && status === "VERIFIED") {
      nextStep({ step: "fypnContract", data: selectedOffer });
      return;
    }

    if (status === "REJECTED" || status === "ATTEMPTED" || data.success === false) {
      selectOfferFailed({
        title: "Bank verification failed",
        message: "Bank verification was not completed. Please try again.",
      });
    }
  };

  render() {
    const { offer, selectedOffer } = this.props;
    const contractUrl =
      (offer && offer.contractUrl) ||
      (selectedOffer && selectedOffer.contractUrl) ||
      "";

    return (
      <Frame contractUrl={contractUrl} onReceiveMessage={this.receiveMessage} />
    );
  }
}

FypnIbvFrame.propTypes = {
  offer: PropTypes.object,
  selectedOffer: PropTypes.object,
};

FypnIbvFrame.defaultProps = {
  offer: {},
  selectedOffer: {},
};

const mapStateToProps = createStructuredSelector({
  offer: activeStepDataSelector(),
  selectedOffer: selectedOfferSelector(),
});

const mapDispatchToProps = (dispatch) => ({
  nextStep: (value) => dispatch(nextStep(value)),
  selectOfferFailed: (value) => dispatch(selectOfferFailed(value)),
});

FypnIbvFrame = connect(mapStateToProps, mapDispatchToProps)(FypnIbvFrame);

export default FypnIbvFrame;
